import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../Layout/PageHeader';
import DynamicDetailGrid from '../../../Components/Grid/DynamicDetailGrid';
import FormButton from '../../../Components/Buttons/FormButton';
import { SetupDetailprop } from '../model/setup.model';


export const SetupDetail: React.FC<SetupDetailprop> = ({
  pageName,
  id,
  columns,
  addUrl,
  listUrl,
  gridUrl,
  editUrl,
  setupHeader  
}) => {
    const navigation=useNavigate();
    const handelEditAction = (data: any) => {
      navigation(`${editUrl}/${data}`);
    };
   

  return (
    <>
      <PageHeader
        addUrl={addUrl}
        listUrl={listUrl}
        gridUrl={gridUrl}
        name={pageName}
        viewType={true}
      />
      <h5 className="text-start mt-1 mb-3">{setupHeader}</h5>
      <DynamicDetailGrid customClassName="my-2" isExpandable={false} columns={3} data={columns} />
        <div className="clearfix"></div>
          {id &&
          <div className="my-2 bg-white rounded py-3">
          <div className="d-flex flex-row-reverse">
            <FormButton
              className="sph-btn me-4"
              handleClick={()=>handelEditAction(id)}
            >
              Edit
            </FormButton>
          </div>
        </div>
         }
    </>
  )
}
